export const ENPS_PREFIX = "V7OBJ:";
export const PST_PREFIX = "PSTOBJ:";

export const ST_CRITERIA_SECURITY_ROLE = "SECURITY_ROLE";

export const OPTION_ALL = "@all";
export const OPTION_BLANK = "@blank";
export const OPTION_YES = "@yes";
export const OPTION_NO = "@no";
export const OPTION_ME = "@staff_id_me";
export const OPTION_ANY = "@any";

export const PUBLICATION_LIST_TIME_TODAY = '@today';
export const PUBLICATION_LIST_TIME_TOMORROW = '@today_day_1';
export const PUBLICATION_LIST_TIME_TODAY_DAY_TWO = '@today_day_2';
export const PUBLICATION_LIST_TIME_TODAY_DAY_THREE = '@today_day_3';
export const PUBLICATION_LIST_TIME_TODAY_DAY_FOUR = '@today_day_4';
export const PUBLICATION_LIST_TIME_TODAY_DAY_FIVE = '@today_day_5';
export const PUBLICATION_LIST_TIME_TODAY_DAY_SIX = '@today_day_6';
export const PUBLICATION_LIST_TIME_TODAY_DAY_SEVEN = '@today_day_7';

export const PUBLICATION_LIST_TIME_OPTIONS: Array<{ id: string, title: string }> = [
    {
        id: PUBLICATION_LIST_TIME_TODAY,
        title: 'Today'
    },
    {
        id: PUBLICATION_LIST_TIME_TOMORROW,
        title: 'Tomorrow'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_TWO,
        title: 'Today + 2'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_THREE,
        title: 'Today + 3'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_FOUR,
        title: 'Today + 4'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_FIVE,
        title: 'Today + 5'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_SIX,
        title: 'Today + 6'
    },
    {
        id: PUBLICATION_LIST_TIME_TODAY_DAY_SEVEN,
        title: 'Today + 7'
    }
];

export const PSTWEB_LIST_VALUE = 'PSTWebListValue';

export const DARK_MODE_KEY = 'dark-mode';


export const APP_THEMES_MAP = {
    'playbook': 'storytelling-theme',
    'journal': 'storytelling-theme',
    'live': 'storytelling-theme',
    'cast': 'storytelling-theme',
    'discover': 'storytelling-theme',
    'embedded': 'storytelling-theme'
}


export const StorytellingLayoutBreakpoints = {
    XSmall: '(max-width: 599.98px)',
    Small: '(min-width: 600px) and (max-width: 899.98px)',
    Medium: '(min-width: 900px) and (max-width: 1279.98px)',
    Large: '(min-width: 1280px) and (max-width: 1439.98px)',
    XLarge: '(min-width: 1440px) and (max-width: 1919.98px)',
    XXLarge: '(min-width: 1920px)',
    // Handset: string; //IN CASE WE NEED
    // Tablet: string; //IN CASE WE NEED
    // Web: string; //IN CASE WE NEED
    // HandsetPortrait: string; //IN CASE WE NEED
    // TabletPortrait: string; //IN CASE WE NEED
    // WebPortrait: string; //IN CASE WE NEED
    // HandsetLandscape: string; //IN CASE WE NEED
    // TabletLandscape: string; //IN CASE WE NEED
    // WebLandscape: string; //IN CASE WE NEED
};
